import React from 'react';

function NotFound() {
  return (
    <div className='d-flex justify-content-center'>
      <h2>Error 404 Page Not Found</h2>
    </div>
  )
}

export default NotFound;